import { v4 as uuidv4 } from "uuid";

export const footer = [
  {
    id: uuidv4(),
    title: "Trading Platforms",
    url: "/trading-platforms",
  },
  {
    id: uuidv4(),
    title: "Back Office",
    url: "/back-office",
  },
  {
    id: uuidv4(),
    title: "Technologies",
    url: "/technologies",
  },
  {
    id: uuidv4(),
    title: "About Us",
    url: "/about-us",
  },
  {
    id: uuidv4(),
    title: "Privacy Policy",
    url: "/privacy-policy",
  },
  {
    id: uuidv4(),
    title: "Cookie Policy",
    url: "/cookies",
  },
  {
    id: uuidv4(),
    title: "Terms and Conditions",
    url: "/terms-and-conditions",
  },
];

export const footerSocials = [
  {
    id: uuidv4(),
    title: "Skype",
    image: "./images/skype.png",
    url: "skype:live:.cid.40c318b7dcd906b7",
  },
  {
    id: uuidv4(),
    title: "Facebook",
    image: "./images/facebook.png",
    url: "https://www.facebook.com/Be-Brokers-660684714262945/",
  },
  {
    id: uuidv4(),
    title: "Telegram",
    image: "./images/telegram.png",
    url: "https://t.me/A2ZBroker",
  },
  {
    id: uuidv4(),
    title: "WhatsApp",
    image: "./images/whatsapp.png",
    url: "https://api.whatsapp.com/send/?phone=380994659026&text&app_absent=0",
  },
];

export const navbar = [
  {
    id: uuidv4(),
    title: "Trading Platforms",
    url: "/trading-platforms",
  },
  {
    id: uuidv4(),
    title: "Back Office",
    url: "/back-office",
  },
  {
    id: uuidv4(),
    title: "Technologies",
    url: "/technologies",
  },
  {
    id: uuidv4(),
    title: "Help",
    url: "/help",
  },
  {
    id: uuidv4(),
    title: "About Us",
    url: "/about-us",
  },
];

export const desktopMenu = [
  {
    id: uuidv4(),
    title: "Trading Platforms",
    url: "/trading-platforms",
    items: [
      "Web Trader Platform (Desktop / Mobile)",
      "MT4 Platform",
      "MT4 Manager",
      "MT4 Plugins",
    ],
  },
  {
    id: uuidv4(),
    title: "Back Office",
    url: "/back-office",
    items: [
      "Client Analytics",
      "Client Area",
      "Marketing and Affiliates",
      "Reports",
      "Payment Solutions",
      "Risk Management",
      "Liquidity Providers",
      "Compliance",
      "Anti-Fraud Management",
      "Algo Trading API",
      "Social Trading API",
    ],
  },
  {
    id: uuidv4(),
    title: "Technologies",
    url: "/technologies",
    items: [
      "Hosting Services",
      "Feed",
      "IT Services",
      "Cybersecurity",
      "Firewalls",
      "Sofware Licences and Solutions",
      "Installation Setup",
      "Website Creation",
      "Branded Emails",
    ],
  },
  {
    id: uuidv4(),
    title: "Help",
    url: "/help",
    items: [
      "Customer Care",
      "Customer Support",
      "Consulting",
      "Success Manager",
    ],
  },
  {
    id: uuidv4(),
    title: "About Us",
    url: "/about-us",
    items: ["About Us", "Contact Us"],
  },
];

export const homeCards = [
  {
    id: uuidv4(),
    title: "Seamless Connection",
    image: "./images/home-seamless.svg",
  },
  {
    id: uuidv4(),
    title: "Tested",
    image: "./images/home-tested.svg",
  },
  {
    id: uuidv4(),
    title: "Fast Integration",
    image: "./images/home-fast.svg",
  },
  {
    id: uuidv4(),
    title: "Track of all activities in one place",
    image: "./images/home-track.svg",
  },
  {
    id: uuidv4(),
    title: "Custom Notification Center",
    image: "./images/home-custom.svg",
  },
  {
    id: uuidv4(),
    title: "Payment System Solution",
    image: "./images/home-payment.svg",
  },
];

export const homeSlidesOne = [
  {
    id: uuidv4(),
    image: "./images/check.svg",
    title: "High-quality platforms",
    desc: "We offer an excellent trading platform that can be customized in order to cater to your company's specific needs. Give the chance to your clients to “conquer” the Markets!",
  },
  {
    id: uuidv4(),
    image: "./images/check.svg",
    title: "Back Office",
    desc: "Our easy-to-navigate through Back Office system allows the management of your entire company from one single location. Suitable for companies of any size, our Be-Brokers Back Office is a leading tool for reaching the best possible performance results. With simple yet powerful features, you will be able to achieve positive results from day one. Our advanced tools will enable you to gain deeper insight into your business data, meet your targets and reach your goals.",
  },
  {
    id: uuidv4(),
    image: "./images/check.svg",
    title: "Simple API Integrations",
    desc: "From our readily accessible API infrastructure, you can seamlessly link with multiple 3rd party providers such as Affiliates, Cashiers, PSPs, VOIP for trustworthy and reliable service.",
  },
];

export const homeSlidesTwo = [
  {
    id: uuidv4(),
    title: "Back Office",
    desc: "BBe-Broker's Back Office solution is perfect for companies of any size and level of experience. Our technology helps you keep track of all activities in one place. We offer deep integrations across the most popular revenue-generating and support systems used by independent firms.  With our incentive and referral solutions, you can streamline your brokerage operations and expand your customer base. Our Back Office enhances productivity and ROI by automating, streamlining, and integrating business processes from data entry to reporting. No more siloed databases with no general ledger or redundant data entry — Our Back Office is optimized for you.",
    desc1: "",
    info: ["Automated activities for minimal cost;", "Built-in Task Manager;"],
  },
  {
    id: uuidv4(),
    title: "Risk Management",
    desc: "Risk management is a critical component in any brokerage. We offer tools to enable you to check technical and market risk quickly and easily. What's more, our risk control function could monitor your trading behavior and properly set over-limit controls on your risk-taking ability in the financial market.",
    desc1: "",
    info: [
      "Market Exposure;",
      "Trader Exposure;",
      "Bridge Log;",
      "Margin Call Accounts;",
    ],
  },
  {
    id: uuidv4(),
    title: "Reports",
    desc: "Generate various valuable reports using the advanced configurable Reporting Tools provided. The software organizes all of your information, controls, and procedures around different type of reports so you can examine them and take action based on accurate knowledge.",
    desc1: "Use rich and fully customizable dashboards to:",
    info: [
      "View patterns and trends in sales, as well as in Marketing;",
      "Visualize Comparisons;",
      "Manage Risk and Compliance;",
    ],
  },
  {
    id: uuidv4(),
    title: "Psp/Banking API Integration",
    desc: "We offer your clients a wide range of payment methods to ensure an easy and secure payment process. We put the power of choice in your hands by allowing you to choose and integrate alternative payment systems that suit your personal needs and preferences. Through our PSP integrations, we provide our customers with a secure, seamless, reliable solution for acquiring online payments pay experience",
    desc1: "",
    info: [
      "Transactions;",
      "Crypto Balance;",
      "Crypto Transactions;",
      "Internal and external Transfers;",
    ],
  },
  {
    id: uuidv4(),
    title: "Trading Platform",
    desc: "Through our web-based application, we provide a single, unified platform for investors to easily place both manual and algorithmic trades across multiple global markets. Our smart user-friendly web application offers cutting-edge features enabling you to conduct your business at any time. It allows you to check quotes and place trades, see account balances, P&L, and other key performance metrics such as funding, reporting, and more. Our platform is your one-stop destination for account information, portfolio management, trade activity, and more.",
    desc1: "",
    info: [
      "Built-in advanced trading tools for analyzing trends and market changes;",
      "Suitable for traders from all backgrounds and experiences;",
      "Reliable software with smooth performance;",
      "Tailored for the client's needs and preferences;",
    ],
  },
];

export const crmSlides = [
  {
    id: uuidv4(),
    image: "./images/crm-risk-management.jpg",
    title: "Risk Management",
    desc: [
      "Currency exposure;",
      "Instrument exposure;",
      "Trader exposure;",
      "Margin Call Accounts;",
      "Bridge Log;",
      "Live Prices;",
    ],
  },
  {
    id: uuidv4(),
    image: "./images/crm-reports.jpg",
    title: "Reports",
    desc: [
      "Big Winners;",
      "Big Losers;",
      "Profit & Loss;",
      "Social Copiers;",
      "Social Leaders;",
      "IP Fraud;",
    ],
  },
  {
    id: uuidv4(),
    image: "./images/crm-sales.jpg",
    title: "Sales",
    desc: [
      "Leads, Users & Customers;",
      "First Time Deposit;",
      "Sales, Partners & Affiliates;",
      "Revenues, Fees, Payments;",
      "Trading Account;",
      "New customer, Lead or User;",
    ],
  },
  {
    id: uuidv4(),
    image: "./images/crm-payment.jpg",
    title: "Payment solutions",
    desc: [
      "Transactions;",
      "Payment Gateways;",
      "Cryptos Balance;",
      "Internal Transfers;",
      "External Transfers;",
      "Bitcoin Transactions;",
    ],
  },
];

export const tradeCards = [
  {
    id: uuidv4(),
    title: "Fast Order Executions",
    image: "./images/trade-fast.svg",
  },
  {
    id: uuidv4(),
    title: "Multiple Instruments to choose from",
    image: "./images/trade-multiple.svg",
  },
  {
    id: uuidv4(),
    title: "User-Friendly Navigation",
    image: "./images/trade-user.svg",
  },
];

export const tradeMT4 = [
  {
    id: uuidv4(),
    image: "./images/trade-client.svg",
    title: "MT4 Client Terminal",
    desc: "Our MT4 Client Terminal offers you an easy-to-navigate, all-inclusive trading experience on the most popular forex platform, all under your brand. The MT4 interface comes fully branded with your logo and color scheme and is integrated with all the most powerful features.",
  },
  {
    id: uuidv4(),
    image: "./images/trade-manager.svg",
    title: "MT4 Manager",
    desc: "Now you can keep personalized trading at your fingertips. The MT4 Manager is the simple solution that will help you easily monitor all of your client's account information in one place, ensuring that their trading experience is profitable, smooth, and worry-free.",
  },
  {
    id: uuidv4(),
    image: "./images/trade-plugins.svg",
    title: "MT4 Plugins",
    desc: "Discover the possibilities of our set of plugins designed specifically for the MT4 platform with your broker. From developer tools for custom trading solutions to education aids, our high-performance plugins are simple to use and easy to install on your MT4 platform.",
  },
];

export const techCards = [
  {
    id: uuidv4(),
    title: "IT Services",
    image: "./images/tech-it.svg",
  },
  {
    id: uuidv4(),
    title: "Installation Setup",
    image: "./images/tech-installation.svg",
  },
  {
    id: uuidv4(),
    title: "Hosting Services",
    image: "./images/tech-hosting.svg",
  },
  {
    id: uuidv4(),
    title: "Software Licenses and Solutions",
    image: "./images/tech-software.svg",
  },
  {
    id: uuidv4(),
    title: "Firewalls",
    image: "./images/tech-firewalls.svg",
  },
  {
    id: uuidv4(),
    title: "Branded Emails",
    image: "./images/tech-emails.svg",
  },
];

export const techWeb = [
  {
    id: uuidv4(),
    image: "./images/tech-premade.svg",
    title: "Pre-made Template Website",
    desc: "Our pre-made templates are packed with great features like SEO-friendly pages, modern design, and high-quality images. These templates will save you an incredible amount of time, as we provide a fully integrated and ready website within 24 hours. With your logo provided, your content, or integrated ready content, you'll have your website ready in no time.",
  },
  {
    id: uuidv4(),
    image: "./images/tech-tailored.svg",
    title: "Tailored-made Website",
    desc: "Create custom-made design, development, and promotion for a website that advertises your brand and steadily grows traffic. With a tailored-made website from us, you'll have full access to affordable web specialists who can promote your services and increase your sales.",
  },
];

export const helpCards = [
  {
    id: uuidv4(),
    title: "Customer Care",
    image: "./images/help-customer.svg",
  },
  {
    title: "Consulting",
    id: uuidv4(),
    image: "./images/help-consulting.svg",
  },
  {
    id: uuidv4(),
    title: "Success Manager",
    image: "./images/help-manager.svg",
  },
];

export const aboutUsCards = [
  {
    id: uuidv4(),
    title: "Technological Innovations",
    image: "./images/about-us-technological.svg",
    desc: "We are an innovation-focused company striving to lead the industry by designing high-quality products and building strong customer relations.",
  },
  {
    id: uuidv4(),
    title: "Customer Satisfaction",
    image: "./images/about-us-heart.svg",
    desc: "It is our dedication and responsibility to offer the best and most reliable products to every customer. We aim to make customers happy with innovative products and seamless communication.",
  },
  {
    id: uuidv4(),
    title: "Self Improvement",
    image: "./images/about-us-self.svg",
    desc: "We understand that self-improvement is the only path to success. We are committed to providing better services each day.",
  },
];
